<template>
  <div class="newcontent" :style="' background-color:'+String(backgoundcolor)">
    <div class="newbody">
      <div class="bodybottom wow fadeInUp">
        <div class="divbox" v-for="(item,index) in listdata">
          <div>
            <img :src="getimgsrc(item.img)"/>
          </div>
          <div class="textbox">
            <div class="new_cont" >
               <span  v-html="$i18n.locale=='zh_HK'?item.name:item.nameEn">
              {{$i18n.locale=='zh_HK'?item.name:item.nameEn}}
            </span>
            </div>

<!--            <p><a :href="item.describe">{{$t('header.Learn')}}</a></p>-->
            <p @click="showmodal(index)">{{$t('header.Learn')}}</p>
          </div>
        </div>
        <Modal class="modal" :show="show" :title="title" @hideModal="hideModal" >
          <img style="width: 60%"   :src="getimgsrc(modeldata.img)"/>
          <p v-html="$i18n.locale=='zh_HK'?modeldata.name:modeldata.nameEn">
            {{$i18n.locale=='zh_HK'?modeldata.name:modeldata.nameEn}}</p>
        </Modal>
      </div>

    </div>

  </div>

</template>

<script>
  import { WOW } from 'wowjs';
  import Modal from '../Modal.vue';
  export default {
    name: "newscontent",
    props:['backgoundcolor','listdata'],
    components: {
      Modal
    },
    data() {
      return {
        title: this.$t('header.Details'),
        show: false,
        modeldata:[],
      }
    },
    mounted(){
      //解决---控制台可能会出现警告
      var options={
        //默认为true
        live:false
      }
      var wow = new WOW(options);
      wow.init();
    },
    created(){
    },
    methods: {
      getimgsrc(imgvalue){
        if (imgvalue == null || imgvalue == '' ) {
          return '-'
        }
        var imgs = imgvalue.replace(/,/g, "")
        return process.env.BASE_IMG + imgs
      },
      hideModal() {
        // 取消弹窗回调
        this.show = false
      },
      showmodal(index){
        this.show = true;
        this.type=index;
        this.modeldata=this.listdata[index];
      },
    },
  }

</script>

<style lang="less" scoped>
  @media only screen and (min-width: 800px) {
    .newcontent {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 5%;

      .newbody {
        width: 85%;
        max-width: 1800px;
        /*display: flex;*/
        /*flex-direction: column;*/
        align-items: center;
        .bodybottom {
          margin-top: 4%;
          /*display: flex;*/
          /*align-items: flex-start;*/
          width: 100%;
          /*justify-content: space-around;*/
          margin-left: 2%;
          .divbox{
            top: 0;
            background-color: white;
            float: left;
            margin: 10px 10px;
            border: 1px solid #72767b;
            padding-top: 20px;
            width: 22.5%;
            height:24vw;
            color: #393939;
            transition: all 0.2s;    //设置动画执行的时间为0.6s
            cursor: pointer;


            div:nth-child(1) {
              overflow: hidden;
              margin-left: 4.5%;
              width: 90%;
              /*height: 50%;*/
              align-items: center;
              img {
                height: auto;
                width: 100%;
              }
            }


            .textbox {
              height: 100%;
              padding: 10px 10px;
              text-align: left;
              font-weight: bold;
              overflow: hidden;
              position: relative;
              .new_cont{
                height: 65%;
                overflow: hidden;
              }
              span {
                height: 15vw;
                /*overflow:auto;*/
                /*display: inline-block;*/
                margin-top: 20px;
                font-size: 18px;
                line-height: 25px;

                /*display: -webkit-box;*/
                /*-webkit-line-clamp: 12;*/
                /*overflow: hidden;*/
                /*!*! autoprefixer: off *!*/
                /*-moz-box-orient: vertical;*/
                /*-webkit-box-orient: vertical;*/
                /*!*! autoprefixer: on *!*/
              }
              /*隐藏滚动条并可以滚动内容*/
              /*span::-webkit-scrollbar {*/
              /*  display: none;*/
              /*}*/
              p {
                text-align: center;
                padding: 1.7em 0;
                font-size: 16px;
               a{
                 color: black;
               }
              }
            }
            .textbox::after {
              float: left;
              content: "...";
              height: 1.5em;
              line-height: 20px;
              /* 为三个省略号的宽度 */
              width: 2em;
              /* 使盒子不占位置 */
              margin-left: -3em;
              /* 移动省略号位置 */
              position: absolute;
              left: 23.5%;
              top: 63.5%;
              padding-right: 5px;
              background-color: #fff;
            }
          }
        }
      }
    }
  }
  @media only screen and (max-width: 800px) {
    .newcontent {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 40px;

      .newbody {
        width: 90%;
        /*max-width: 1750px;*/
        /*display: flex;*/
        /*flex-direction: column;*/
        /*align-items: center;*/

        .bodybottom {
          display: flex;
          flex-wrap: wrap;
          margin-top: 4%;
          /*display: flex;*/
          /*align-items: flex-start;*/
          width: 100%;
          align-items: center;
          /**/
          justify-content: center;

          .divbox {
            /*background-color: white;*/
            /*float: left;*/

            margin: 2% 3%;
            border: 1px solid #72767b;
            padding-top: 2vw ;
            width: 43%;
            color: #393939;
            /*transition: all 0.6s;    //设置动画执行的时间为0.6s*/
            /*cursor: pointer;*/

            div:nth-child(1) {
              overflow: hidden;
              margin-left: 3%;
              text-align: center;
              align-items: center;
              /*width: 80%;*/
              /*margin: 1% 2%;*/
              height: 50%;
              img{
                width:100%;

              }
            }

            .textbox {
              /*height: 40vw;*/
              padding: 1% 3%;
              text-align: left;
              position: relative;
              overflow: hidden;
              font-weight: bold;
              span {
                height: 38vw;
                overflow:auto;
                display: inline-block;
                margin-top: 2%;
                font-size: 1.5em;
                line-height: 1.6em;
                text-align: left;
              }

              p {
                height: 2vh;
                font-weight: bold;
                width: 100%;
                text-align: center;
                padding: 12% 0;
                font-size: 1.5em;
                /*padding-bottom: 1%;*/
                a{
                  color: black;
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/News/newscomponents/newscontent.vue